module.exports = __webpack_public_path__ + "static/media/Middle_Second_Building_Light.7177c1e1.png";